/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2018, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../../../lib/@waca/core-client/js/core-client/ui/core/View',
	'react',
	'react-dom',
	'@ba/ba-ui-carbon-toolkit',
	'jquery',
	'../../../../../app/nls/StringResources',
	'@ba/ba-graphics/dist/icons-js/align--horizontal-left_32',
	'@ba/ba-graphics/dist/icons-js/align--horizontal-center_32',
	'@ba/ba-graphics/dist/icons-js/align--horizontal-right_32',
	'@ba/ba-graphics/dist/icons-js/align--vertical-top_32',
	'@ba/ba-graphics/dist/icons-js/align--vertical-center_32',
	'@ba/ba-graphics/dist/icons-js/align--vertical-bottom_32'
], function(View, React, ReactDOM, UI_Toolkit, $, stringResources, iconAlignLeft, iconAlignCenter, iconAlignRight, iconAlignTop, iconAlignMiddle, iconAlignBottom) {
	let AlignDialog = View.extend({

		init: function(options = {}) {
			AlignDialog.inherited('init', this, arguments);
			this.action = options.actions ? options.actions.apply : options.action;
		},

		//@dodo convoluted that have to provide this function so that renderCallBack can be called.
		//Will fix this in dashboard-common/ui/AuthoringToolbar to pass in the authoringToolbar instance when instantiate an instance
		preload: function() {
			return Promise.resolve();
		},

		//@dodo convoluted that have to provide this function
		//Will fix this in dashboard-common/ui/AuthoringToolbar to pass in the authoringToolbar instance when instantiate an instance
		renderCallBack: function(authoringToolbar) {
			this.authoringToolbar = authoringToolbar;
			this.authoringToolbar.on('flyout:hide', this._unmountReactComponent.bind(this));
		},

		remove: function() {
			this._unmountReactComponent();
			this.authoringToolbar.off('flyout:hide', this._unmountReactComponent.bind(this));
			this.action = null;
			this.authoringToolbar = null;
			if (this.$container) {
				this.$container.remove();
				this.$container = null;
			}
			AlignDialog.inherited('remove', this, arguments);
		},

		_unmountReactComponent: function() {
			//Unmount the React component when clicks anywhere in the dashboard to close the flyout
			if (this.$container) {
				ReactDOM.unmountComponentAtNode(this.$container[0]);
				this.$container = null;
			}
		},

		selectItem: function(value) {
			this.action(value);
			//this.onUpdate is actually bound to the AuthoringToolbar.hide function
			//When a value is selected, call this.onUpdate to destroy the flyout. So when the flyout is destroyed unmount the Reaact component
			return this.onUpdate()
				.then(() => {
					if (this.$container) {
						ReactDOM.unmountComponentAtNode(this.$container[0]);
						this.$container = null;
					}
				});
		},

		render: function() {
			const _this = this;
			return new Promise((resolve) => {
				const Menu = UI_Toolkit.Menu;
				const MenuList = UI_Toolkit.Menu.List;
				class AlignMenuWidget extends React.Component{
					constructor(props){
						super(props);
						this.state = {
							selected: {}
						};
					}

					_onChange(label, v) {
						let newSelection = {};
						const oldSelection = this.state.selected;

						for (let item in oldSelection) {
							if (oldSelection.hasOwnProperty(item)) {
								newSelection[item] = oldSelection[item];
							}
						}

						newSelection[label] = v;
						this.setState({ selected: newSelection });
						_this.selectItem(v);
					}

					render() {
						return React.createElement(
							Menu, {
								onChange: this._onChange.bind(this),
								selected: this.state.selected
							}, [
								React.createElement(
									MenuList, {
										name: 'align',
										content: [{
											label: stringResources.get('alignWidgetLeft'),
											value: 'left',
											icon: iconAlignLeft.default
										}, {
											label: stringResources.get('alignWidgetCenter'),
											value: 'center',
											icon: iconAlignCenter.default
										}, {
											label: stringResources.get('alignWidgetRight'),
											value: 'right',
											icon: iconAlignRight.default
										}, {
											label: stringResources.get('alignWidgetTop'),
											value: 'top',
											icon: iconAlignTop.default
										}, {
											label: stringResources.get('alignWidgetMiddle'),
											value: 'middle',
											icon: iconAlignMiddle.default
										}, {
											label: stringResources.get('alignWidgetBottom'),
											value: 'bottom',
											icon: iconAlignBottom.default
										}]
									}
								)
							]
						);
					}
				}

				this.$container = $('<div/>', { 'class': 'ba-theme-default selectionList' });
				this.$el.addClass('content').append(this.$container);
				ReactDOM.render(React.createElement(AlignMenuWidget), this.$container[0], resolve);
			});
		}

	});

	return AlignDialog;
});
